const Content = {
    'network': {
        'la': {
            'region': 'USA - West',
            'title': 'Los Angeles',
            'address1': '12101 W. Bluff Creek Drive',
            'address2': 'Los Angeles',
            'address3': 'CA 90094',
            'address4': 'United States',
            'phone': '+1 (323) 406 6200',
            'mapUrl': 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d827.1224942304526!2d-118.40453795334919!3d33.9799462980769!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80c2b1bfcd713e5b%3A0x2b9b07ad60099ab9!2s12101%20Bluff%20Creek%20Dr%2C%20Playa%20Vista%2C%20CA%2090094!5e0!3m2!1sen!2sus!4v1641492918790!5m2!1sen!2sus'
        },
        'ny': {
            'region': 'USA - East',
            'title': 'New York',
            'address1': 'One World Trade Center',
            'address2': '(63rd Floor)',
            'address3': '285 Fulton Street',
            'address4': 'New York ',
            'address5': 'NY 10007',
            'address6': 'United States',
            'phone': '+1 (323) 406 6200',
            'mapUrl' : 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3024.227495180534!2d-74.01535758477817!3d40.713008179331744!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c25a1bcfb6ae35%3A0x83b61a4dc69b3439!2sOne+World+Trade+Center%2C+285+Fulton+St%2C+New+York%2C+NY+10006!5e0!3m2!1sen!2sus!4v1521653161015'
        },
        'london': {
            'region': 'Europe',
            'title': 'London',
            'address1': '100 Leman Street (3rd Floor)',
            'address2': 'London, E1 8EU',
            'address3': 'United Kingdom',
            'phone': '',
            'mapUrl': 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d620.7627596207229!2d-0.06939640968695807!3d51.5122796288288!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4876033582c6fe97%3A0x3c54b1084849c312!2s100%20Leman%20St%2C%20Whitechapel%2C%20London%20E1%208GH%2C%20UK!5e0!3m2!1sen!2sus!4v1602521445552!5m2!1sen!2sus'
        },
		'si': {
            'region': 'Asia',
            'title': 'Singapore',
            'address1': '18 Cross Street, #02-101',
            'address2': 'Singapore 048423',
			'address3': 'Singapore',
            'phone': '',
            'mapUrl': 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.817136710765!2d103.84489661491247!3d1.283592062141917!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da190c8e6a9c09%3A0x351859d4daf9841a!2s18%20Cross%20St%2C%20%2302-101%2C%20Singapore%20048423!5e0!3m2!1sen!2sus!4v1641331994629!5m2!1sen!2sus'
        }
    }
};

export { Content };
